import { render, staticRenderFns } from "./InventoryTransferReport.vue?vue&type=template&id=97b22a02"
import script from "./InventoryTransferReport.vue?vue&type=script&lang=js"
export * from "./InventoryTransferReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports